// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Button } from 'semantic-ui-react';
import { connect } from 'react-redux';
// local
// views
import DropdownCylinderQtd from 'app/ui/commons/DropdownCylinderQtd';
// actions
import { updateCylinderQtd } from 'app/redux/actions/requestDelivery/data';

class RequestTableRow extends Component {
    constructor(props) {
        super(props);
        this.state = { row: props.row, isEdit: false };
    }

    onEditClicked = () => {
        this.setState({ oldValue: this.state.row.pendingCylinderQtdEdit, isEdit: true });
    };

    onSaveClicked = () => {
        this.setState({ isEdit: false });
        const { row, oldValue } = this.state;
        const diff = row.pendingCylinderQtdEdit - oldValue;
        this.props.dispatch(updateCylinderQtd(row.supplierId, row.id, row.pendingCylinderQtdEdit, diff));
    };

    onInputChange = value => {
        const row = {
            ...this.state.row,
            pendingCylinderQtdEdit: value,
        };
        this.setState({ row });
    };

    render() {
        const { row, isEdit } = this.state;
        const address = `${row.address} - ${row.city}, ${row.state}`;
        return (
            <Table.Row>
                <Table.Cell>{row.serviceNumber}</Table.Cell>
                <Table.Cell className="bold uppercase wrap">{row.name}</Table.Cell>
                <Table.Cell className="wrap">{address}</Table.Cell>
                <Table.Cell textAlign="center">{row.cylinderSize}m³</Table.Cell>
                <Table.Cell textAlign="center">
                    {isEdit ? (
                        <DropdownCylinderQtd
                            maxValue={row.pendingCylinderQtd + row.emptyCylinderQtd}
                            minValue={1}
                            value={row.pendingCylinderQtdEdit}
                            onChange={this.onInputChange}
                        />
                    ) : (
                        row.pendingCylinderQtdEdit
                    )}
                </Table.Cell>
                <Table.Cell>
                    {isEdit ? (
                        <Button onClick={this.onSaveClicked} icon="check" circular size="mini" />
                    ) : (
                        <Button onClick={this.onEditClicked} icon="pencil" circular size="mini" />
                    )}
                </Table.Cell>
            </Table.Row>
        );
    }
}

RequestTableRow.propTypes = {
    dispatch: PropTypes.func,
    row: PropTypes.object,
};

export default connect()(RequestTableRow);
